module.exports = __webpack_public_path__ + "img/next.13fcf7c4.svg";